export default __webpack_public_path__ + "static/media/websiteVsWebApp.47e52a22.md";